module.exports = __webpack_public_path__ + "static/media/1.61744098.jpg";